import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { Outlet, Route } from 'react-router';
import { AddRoutePage, EditRoutePage, RoutesPage } from '#route-bundles/authenticated.tsx';
import { fallbackRenderNotFound } from '#screens/errors/fallbackRenderNotFound.tsx';
import { LoadingSpinner } from '#screens/loading/LoadingSpinner.tsx';

export const routesRootRoute = (
  <Route
    element={
      <Suspense fallback={<LoadingSpinner />}>
        <Outlet />
      </Suspense>
    }
  >
    <Route index={true} element={<RoutesPage />} />
    <Route path="add" element={<AddRoutePage />} />
    <Route
      path=":routeId"
      element={
        <ErrorBoundary fallbackRender={fallbackRenderNotFound}>
          <EditRoutePage />
        </ErrorBoundary>
      }
    />
  </Route>
);
